/**
 * Sends a JSON string to the host app. All checks run in order; only the bridge(s)
 * your shell injects will be present (Swift app, Kotlin app, or React Native).
 *
 * | Stack            | What to implement |
 * |------------------|-------------------|
 * | React Native     | `react-native-webview` injects `window.ReactNativeWebView.postMessage`. Handle `onMessage` / `JSON.parse(nativeEvent.data)`. |
 * | Swift (iOS)      | `WKWebViewConfiguration.userContentController.add(self, name: "nautEmbedded")` — JS calls `webkit.messageHandlers.nautEmbedded.postMessage`. |
 * | Kotlin (Android) | `webView.addJavascriptInterface(Bridge(), "NautEmbeddedBridge")` with `@JavascriptInterface fun postMessage(payload: String)`. |
 */
export function postMessageToNativeWebView(payload) {
  if (typeof window === "undefined") {
    return;
  }
  const str = typeof payload === "string" ? payload : JSON.stringify(payload);
  try {
    if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === "function") {
      window.ReactNativeWebView.postMessage(str);
    }
    if (window.webkit?.messageHandlers?.nautEmbedded) {
      window.webkit.messageHandlers.nautEmbedded.postMessage(str);
    }
    if (window.NautEmbeddedBridge && typeof window.NautEmbeddedBridge.postMessage === "function") {
      window.NautEmbeddedBridge.postMessage(str);
    }
  } catch (e) {
    console.warn("postMessageToNativeWebView failed", e);
  }
}
